import React, { Component, PropTypes } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
    setCheckBox, selectVisibleItems, selectItems, deselectItems, filterTicket, archive,
    getInbox, setTicketUnread, setNotification, resetStaffList, archiveToggleModal,
    generateTaskFromTicket, archiveRelational, forceUncheckSelectedTickets,
    setAppModule, setOpenedSubmenu, setClientSubModule, setEmailSenderExternalAttachments,
    getClientId, taskCreatorModalToggle, preCacheDocumentsBulk, downloadDocumentsZip, navigateToDsDocumentFromTicket,
    getDsDocsAndPackages, fetchExistingClient, setEmailSenderModule, fetchClientContract, setCustomDsDocumentsModule,
    setDSDocumentsOpenedPackage, setDSDocumentsSubModule, setOpenInvitationEditorFromTicket, getStakeholdersByPackageId,
    resendClientRemainder, updatePackagesFromConnective, getOneDsPackageById, fetchClientOptionsDict, getActualizedPackageForInvitation
} from 'state/actions'
import DOMify from 'react-domify'
import { Table, Thead, Th, Tr, Td, collapseTd } from 'components/reactable'
import ComponentPageDom from 'elements/ComponentPageDom'
import RefreshBtn from './refreshBtn'
import {
    dateFormatter, getTheLanguageCodeByAnyLanguageOnAnyLanguage
} from 'lib/helpers'
import SelectWrap from './shared/select/SelectWrap'
import styles from './inbox.scss'
import stylesExtra from 'css/extra/buttons.scss'
import rt from './reactable.scss'
import underscore from 'underscore'
import { map } from 'lodash/collection'
import cs from 'classnames'
import c from 'state/constants'
import TaskCreator from './taskCreator/index'
import LinkDocumentModal from './DSDocuments/LinkDocumentModal'
import LinkAndUploadButton from './DSDocuments/linkAndUploadButton'
import InboxDocumentsSigningModal from './inboxDocumentsSigningModal'
import ClientLinkingModal from './inbox/ClientLinkingModal'

// import EmailButton from './emailSender/emailButton'
import { findContractIdByContractNumber, canSendInvitation } from 'lib/helpers'

// ignore all loaders defined on the webpack conf
import i18n from 'lib/i18n'
import nesProp from 'nested-property'
import ReminderEmailStatusDialog from './DSDocuments/reminderEmailStatusDialog'

const TICKET_CATEGPRIES_WHITE_LIST_FOR_QUICK_REPLY = ["15", "8", "9", "12", "2", "6"]

const _ = i18n('inbox')

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
    },
    content: {
        position: 'relative',
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '0',
    },
}

const mapDispatchToProps = dispatch => bindActionCreators(
    {
        dispatch, setNotification, setCheckBox, selectVisibleItems, filterTicket, archive,
        getInbox, setTicketUnread, selectItems, deselectItems, resetStaffList, archiveToggleModal,
        generateTaskFromTicket, archiveRelational, forceUncheckSelectedTickets, setAppModule,
        setOpenedSubmenu, setClientSubModule, setEmailSenderExternalAttachments, getClientId,
        taskCreatorModalToggle, preCacheDocumentsBulk, downloadDocumentsZip, getDsDocsAndPackages, fetchExistingClient,
        setEmailSenderModule, fetchClientContract, getStakeholdersByPackageId, resendClientRemainder,
        updatePackagesFromConnective, getOneDsPackageById, fetchClientOptionsDict, getActualizedPackageForInvitation
    },
    dispatch
)

const DOCUMENT_FILE_SOURCE_DSDOCUMENT = 'DOCUMENT_FILE_SOURCE_DSDOCUMENT'
const DOCUMENT_FILE_SOURCE_TICKET_DOCUMENT = 'DOCUMENT_FILE_SOURCE_TICKET_DOCUMENT'

@connect(
    ({
        inbox: { items, filter, selectValue, staff, archiveData },
        DSDocuments: { items: dsDocuments, templates: dsDocTemplates },
        app: { security, module, security: { EmailTemplateRelations } },
        clients: { clientData },
        client: { clientOptionsDict },
    }) => ({
        items, filter, selectValue, staff, archiveData, security, module, dsDocuments, dsDocTemplates, clientData,
        EmailTemplateRelations, clientOptionsDict
    }),
    mapDispatchToProps
)
export default class Inbox extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        items: PropTypes.arrayOf(PropTypes.object),
        filter: PropTypes.string.isRequired,
        selectValue: PropTypes.string.isRequired,
        modalIsOpen: PropTypes.bool,
        setNotification: PropTypes.func.isRequired,
        setCheckBox: PropTypes.func.isRequired,
        selectVisibleItems: PropTypes.func.isRequired,
        getStakeholdersByPackageId: PropTypes.func.isRequired,
        resendClientRemainder: PropTypes.func.isRequired,
        getOneDsPackageById: PropTypes.func.isRequired,
        updatePackagesFromConnective: PropTypes.func.isRequired,
        selectItems: PropTypes.func.isRequired,
        deselectItems: PropTypes.func,
        filterTicket: PropTypes.func.isRequired,
        archive: PropTypes.func.isRequired,
        resetStaffList: PropTypes.func.isRequired,
        archiveToggleModal: PropTypes.func.isRequired,
        generateTaskFromTicket: PropTypes.func.isRequired,
        getInbox: PropTypes.func.isRequired,
        setTicketUnread: PropTypes.func.isRequired,
        forceUncheckSelectedTickets: PropTypes.func.isRequired,
        setAppModule: PropTypes.func.isRequired,
        setOpenedSubmenu: PropTypes.func.isRequired,
        setClientSubModule: PropTypes.func.isRequired,
        setEmailSenderExternalAttachments: PropTypes.func.isRequired,
        setEmailSenderModule: PropTypes.func.isRequired,
        fetchClientContract: PropTypes.func.isRequired,
        getClientId: PropTypes.func.isRequired,
        preCacheDocumentsBulk: PropTypes.func.isRequired,
        fetchExistingClient: PropTypes.func.isRequired,
        getActualizedPackageForInvitation: PropTypes.func.isRequired,
        dsDocuments: PropTypes.arrayOf(PropTypes.object),
        dsDocTemplates: PropTypes.arrayOf(PropTypes.object),
    }

    constructor(props) {
        super(props)

        let moduleKeyToSet = nesProp.get(props, "EmailTemplateRelations.EmailTemplateModules.inboxReplyToWillemot.value")

        this.state = {
            isOpened: {}, visibilityOf: {}, archiveIsOpen: false,
            inboxUsers: [],
            inboxItems: [],
            archiveConfirm: false,
            confirmationModal: false,
            archiveType: null,
            documentCheckList: {},
            precacheInProgress: false,
            waitingModal: false,
            isOpenLinkDocumentModal: false,
            signDocumentsModalIsOpen: null,
            clientLinkingIsOpen: false,
            //emailerIsOpen: false,
            //moduleOptionsForEmail: null,
            moduleKeyToSet,
            reminderConfirmationModal: false,
            reminderSentSuccessFlag: false,
            invitationBlocked: false
        }
    }

    componentDidMount() {
        this.refresh(true)
        const { clientOptionsDict } = this.props

        if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
            fetchClientOptionsDict()
        }

    }

    componentWillUnmount() {
        const { forceUncheckSelectedTickets } = this.props
        forceUncheckSelectedTickets()
    }

    refresh(force) {
        const { getInbox } = this.props
        getInbox(force)
    }

    switch(id) {
        const { isOpened } = this.state
        const isElemOpened = !isOpened[id]
        this.adjustCollapseSectionStyle(id, isElemOpened)
        this.setState({ isOpened: { ...this.state.isOpened, [id]: isElemOpened } })
    }

    adjustCollapseSectionStyle(id, isOpened) {

        const collapseWrapperElements = Array.from(document.querySelectorAll('[class*="collapseWrapper"'))
        const ticketDescriptionElements = Array.from(document.querySelectorAll('[class*="ticket-description"'))
        const collapseWrapperMap = {}
        const ticketDescriptionMap = {}
        for (const oneCollapseElem of collapseWrapperElements) {
            const attribute = oneCollapseElem.getAttribute('data-ticketIdAttr')
            nesProp.set(collapseWrapperMap, attribute, oneCollapseElem)
        }
        for (const oneTicketDescriptionElem of ticketDescriptionElements) {
            const attribute = oneTicketDescriptionElem.getAttribute('data-ticketIdAttr')
            nesProp.set(ticketDescriptionMap, attribute, oneTicketDescriptionElem)
        }
        if (isOpened) {
            const ticketDescriptionHeight = ticketDescriptionMap[id].offsetHeight
            collapseWrapperMap[id].style.marginTop = `${ticketDescriptionHeight - 14}px`
        } else {
            collapseWrapperMap[id].style.marginTop = `0`
        }
    }

    check(ev, id) {
        ev.stopPropagation()
        const { setCheckBox } = this.props
        setCheckBox(id)
    }

    /**
     * Get the staff name based on user id
     *
     * @param {string} userId the staff user unique id
     */
    getStaffName(userId) {
        const { staff } = this.props

        let name = '-'

        staff.forEach(element => {
            if (element.userId == userId) {
                name = element.firstName + ' ' + element.lastName
            }
        })

        return name
    }

    /**
     * Return the status string based on task isCompleted value
     *
     * @param {boolean} status
     */
    getTaskStatus(status) {
        if (status == true) {
            return _('completed')
        } else {
            return _('uncompleted')
        }
    }

    /**
     * Get if the user has access to send ticket to task
     */
    getInboxSecurity() {
        const { security } = this.props
        let inboxSecurity = false

        if (security.actions && security.actions.length) {
            security.actions.map((value, key) => {
                if (value.actionName === 'Inboxtask') {
                    if (typeof value.actionAllowed === 'string') {
                        if (value.actionAllowed === 'true') {
                            inboxSecurity = true
                        }
                    }
                }
            })
        }

        return inboxSecurity;
    }

    /**
     * Get if the user has access to download doc
     */
    getDownloadDocSecurity() {
        const { security } = this.props
        let downloadDocSecurity = false

        if (security.actions && security.actions.length) {
            security.actions.map((value, key) => {
                if (value.actionName === 'downloaddoc') {
                    if (typeof value.actionAllowed === 'string') {
                        if (value.actionAllowed === 'true') {
                            downloadDocSecurity = true
                        }
                    }
                }
            })
        }

        return downloadDocSecurity
    }

    getEmailSecurity() {
        const { security } = this.props
        let emailSecurity = false

        if (security.actions && security.actions.length) {
            security.actions.map((value, key) => {
                if (value.actionName === 'createmail') {
                    if (typeof value.actionAllowed === 'string') {
                        if (value.actionAllowed === 'true') {
                            emailSecurity = true
                        }
                    }
                }
            })
        }

        return emailSecurity
    }

    /**
     * Handles the archiver confirmation toggle modal visibility toggle
     *
     * @param {string}
     */
    toggleArchiveConfirmationModal() {
        this.setState({
            confirmationModal: !this.state.confirmationModal,
        })
    }

    /**
     * Handles the archiver select input change event
     *
     * @param {object} value the value of the arhiver select input
     * @param {array} items the list of items from table
     */
    handlerArchiverSelectChange(value, items) {
        const { archiveRelational, archive } = this.props

        // Archive for all users if value is archive
        if (value.value == 'archive' || value.value == 'archive_self' || value.value == 'archive_others') {
            const { items } = this.props
            let stateItems = []

            items.map((value, key) => {
                stateItems[key] = { ...value }
            })

            stateItems = stateItems.filter(item => item.checked)

            this.setState({
                inboxItems: stateItems,
                archiveType: value.value
            })

            this.toggleArchiveConfirmationModal()
        }
    }

    archiveBtn(checkedItemCount, items, downloaddoc) {
        const { archive } = this.props
        const { documentCheckList } = this.state
        let areThereSelectedDoc = false

        // check if are there a checked element in sub checklist
        if (documentCheckList && Object.keys(documentCheckList).length > 0) {
            Object.keys(documentCheckList).forEach((oneObjKey) => {
                areThereSelectedDoc = areThereSelectedDoc || (documentCheckList[oneObjKey].length > 0)
            })
        }

        // Define the arhive list
        let archiveOptions = [
            { value: '', label: _('selectArchiveOption') },
            { value: 'archive', label: _('archiveForAll') },
            { value: 'archive_self', label: _('archiveCurrent') },
            { value: 'archive_others', label: _('archiveOthers') },
        ]

        return (
            <div className={styles.buttonContainer}>
                {
                    downloaddoc &&
                    <input
                        key="downloaddocmultiple"
                        onClick={() => this.handlerDownloadGlobalSelectChange(items)}
                        disabled={!checkedItemCount && !areThereSelectedDoc}
                        type="button"
                        className={styles.greyButton}
                        value={_('generalDownloadButton')}
                    />
                }

                <SelectWrap
                    key="s"
                    value={""}
                    options={archiveOptions}
                    onChange={(v) => { this.handlerArchiverSelectChange(v, items) }}
                    className={styles.archiveSelect}
                    isDisabled={!checkedItemCount}
                />

                {this.getInboxSecurity() &&
                    <input
                        type="button"
                        className={styles.greyButton}
                        value={_("sendAsTask")}
                        disabled={!checkedItemCount}
                        onClick={() => { this.handleTaskCreatorModalToggling() }}

                    />
                }
            </div>
        )
    }


    /**
     * Archive items by type on confirmation
     */
    archiveByType() {
        const { archiveRelational, archive } = this.props
        const { archiveType } = this.state
        const items = this.state.inboxItems

        // Archive for all users if value is archive
        if (archiveType == 'archive') {
            archiveRelational(items, 'all')
        }

        // Archive for just the current user if value is archive_self
        if (archiveType == 'archive_self') {
            archive(items)
        }

        // Archive for other users if value is archive_others
        if (archiveType == 'archive_others') {
            archiveRelational(items, 'others')
        }

        this.setState({ archiveType: null })
        this.toggleArchiveConfirmationModal(null)
    }

    archiveConfirmPopup() {
        const items = this.state.inboxItems
        const itemsLength = items && items.length || 0

        const titleMsg = _('confirmYourArchiveAction')
        let msg = `${_('archiveSelfConfirmMessage')}`

        const { archiveType } = this.state

        // Archive for just the current user if value is archive_self
        if (archiveType == 'archive_self') {
            msg = _('archiveSelfConfirmMessage')
        }

        // Archive for other users if value is archive_others
        if (archiveType == 'archive_others') {
            msg = _('archiveOthersConfirmMessage')
        }

        return (
            <div className={styles.archiveModalContent}>
                <span className={styles.title}>{titleMsg}</span>
                <span className={styles.message}>{msg}</span>
                <div className={styles.archiveModalButtons}>
                    <span
                        onClick={() => this.toggleArchiveConfirmationModal()}
                        className={styles.cancel}
                    >
                        {_("cancel")}
                    </span>
                    <input
                        onClick={() => this.archiveByType()}
                        type="button"
                        className={styles.greyButton + " enabled"}
                        value={_("confirm")}
                    />
                </div>
            </div>
        )
    }

    handleCheckAll = () => {
        const { selectVisibleItems, setNotification } = this.props
        const { allSelected, visibleIds } = this

        if (!allSelected) {
            const msg = `${_('all')} ${visibleIds.length} ${_('numOfSelectedMsg')}`
            setNotification(msg, 'info')
        }
        selectVisibleItems(visibleIds)
    }

    handleVisibleList = (visibleIds) => {
        const visibilityOf = {}
        for (const id of visibleIds) {
            visibilityOf[id] = true
        }
        this.visibleIds = visibleIds
        this.setState({ visibilityOf })
    }

    /**
     * This function helps to use an icon on a safe way
     */
    getIcon = iconName => {
        try {
            return require(`resources/images/${iconName}`)
        } catch (err) {
            return require(`resources/images/icn-no-result.svg`)
        }
    }

    fetchDocumentsToAttachment(documents, typeDocument) {
        let files = []
        if (documents) {
            documents.forEach((oneDocument) => {
                files.push({
                    name: typeDocument,
                    date: "-",
                    id: oneDocument,
                    typeDocument: typeDocument
                })
            })
        }

        return files
    }

    navigateToClientContracts(clientId, contractId, initialArguments) {
        const { setAppModule, setOpenedSubmenu, setClientSubModule } = this.props
        setAppModule(c.CLIENTS, clientId)
        setOpenedSubmenu(contractId, initialArguments)
        setClientSubModule('contracts')
    }

    navigateToClientClaims(clientId, claimId, initialArguments) {
        const { setAppModule, setOpenedSubmenu, setClientSubModule } = this.props

        setAppModule(c.CLIENTS, clientId)
        setOpenedSubmenu(claimId, initialArguments) // submenuOpened: claimId, subModuleZoom: {}
        setClientSubModule('claims') // subModule: 'claims' subModuleZoom: ''
    }

    navigateToClientTarifications(clientId, tarificationId, initialArguments) {
        const { setAppModule, setOpenedSubmenu, setClientSubModule } = this.props
        setAppModule(c.CLIENTS, clientId)
        setClientSubModule('tarification')
        setOpenedSubmenu(tarificationId, initialArguments)
    }

    /**
     * This function will change the opened module (forward browser) to the client contract/claims module
     * @param {*} ticketObj
     * @param {*} sendMail
     * @param {*} autoSelectTemplate
     */
    gotToContractOrClaimOfClient = (ticketObj, sendMail = false, autoSelectTemplate = false, quickReply = false) => {
        const { setEmailSenderExternalAttachments, getClientId, setNotification } = this.props
        let contractId = ticketObj && ticketObj.ticketDetails && ticketObj.ticketDetails.contractId
        let claimId = ticketObj && ticketObj.ticketDetails && ticketObj.ticketDetails.claimId
        let tarificationId = ticketObj && ticketObj.ticketDetails && ticketObj.ticketDetails.tarificationId
        getClientId(contractId, claimId, tarificationId).then((clientId) => {
            // no clientId we can not change the module
            if (!clientId) {
                setNotification(_('ticketNoClientAffected'), 'error')
                return
            }

            // set attachments for the email sender from default if want to send email
            if (sendMail) {
                let files = this.fetchDocumentsToAttachment(ticketObj.documents, ticketObj.typeDocument)
                setEmailSenderExternalAttachments(files)
            }

            // if we have contractId we have to navigate to client contracts
            if (contractId) {
                this.navigateToClientContracts(clientId, contractId, {
                    autoEmailModalOpen: sendMail,
                    autoSelectTemplate,
                    startedFromModule: c.EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT,
                    quickReply,
                    ticketId: ticketObj.id,
                })
                // stop here this function
                return
            }

            if (tarificationId) {
                this.navigateToClientTarifications(clientId, tarificationId, {
                    autoEmailModalOpen: sendMail,
                    autoSelectTemplate,
                    startedFromModule: c.EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT,
                    quickReply,
                    ticketId: ticketObj._id
                })
                // stop here this function
                return
            }

            // if we have ClaimId we have to navigate to client claims
            if (claimId) {
                this.navigateToClientClaims(clientId, claimId, {
                    autoEmailModalOpen: sendMail,
                    autoSelectTemplate,
                    startedFromModule: c.EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT,
                    quickReply,
                    ticketId: ticketObj._id
                })
            }
        })
    }

    /**
     * This function will change the opened module (forward browser) to the client contract/claims module
     */
    // openEmailer = async (ticketObj) => {
    //     const { setNotification, getClientId, fetchExistingClient, setEmailSenderModule, fetchClientContract } = this.props
    //     let { moduleOptionsForEmail, moduleKeyToSet } = this.state

    //     // collect information from ticket object for further initialization
    //     let contractId = ticketObj && ticketObj.ticketDetails && ticketObj.ticketDetails.contractId
    //     let claimId = ticketObj && ticketObj.ticketDetails && ticketObj.ticketDetails.claimId
    //     let tarificationId = ticketObj && ticketObj.ticketDetails && ticketObj.ticketDetails.tarificationId


    //     //++++ LAOD client data +++++
    //     let clientId = await getClientId(contractId, claimId, tarificationId)

    //     // guard function if no client id
    //     if (!clientId) {
    //         setNotification(_('ticketNoClientAffected'), 'error')
    //         return
    //     }

    //     let singleClientData = await fetchExistingClient(clientId)
    //     //--- EOF load client data -----


    //     //++++ LAOD contract data +++++
    //     let contract
    //     // get detailed contract data to know to predefine the broker data
    //     if (contractId) {
    //         let resultContract = await fetchClientContract(contractId)
    //         contract = nesProp.get(resultContract, "response")

    //         // let brokerNumber = nesProp.get(resultContract, "response.contractDetails.brokerNumber")
    //         // let brokerInfo = getBrokerFullInfoByNumber(brokerNumber, brokers)
    //         // let brokerEmailAddress = nesProp.get(brokerInfo, "main.emails.0")
    //         // let brokerName = nesProp.get(brokerInfo, "main.name")
    //     }
    //     //--- EOF load contract data -----


    //     //++++ ADD attachments to email sender +++++
    //     // set attachments for the email sender from default if want to send email

    //     // let files = this.fetchDocumentsToAttachment(ticketObj.documents, ticketObj.typeDocument)
    //     // await setEmailSenderExternalAttachments(files)

    //     //--- EOF add attachments to email sender -----


    //     // compose the argument collection for email sender
    //     moduleOptionsForEmail = await this.collectVariableValues(ticketObj, singleClientData, contractId, contract)

    //     // open the email sender modal by setting the moduleKey flags in the store
    //     // set the moduleKey to trigger the email sender modal with the correct templates
    //     await setEmailSenderModule(moduleKeyToSet, c.EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT)

    //     // enable the emailer modal locally in the state to render it
    //     this.setState({ emailerIsOpen: true, moduleOptionsForEmail })
    // }

    /**
     * Navigate to package details from a reminder ticket
     * @param {*} packageId
     */
    onNavigateToPackageClick(packageId) {
        const { dispatch } = this.props
        dispatch(setCustomDsDocumentsModule(c.DSDOCUMENTS, null))
        dispatch(setDSDocumentsOpenedPackage(packageId))
        dispatch(setDSDocumentsSubModule('detailedPackage'))
    }

    /**
     * Open reminder sending from package list for unfinished packages
     * @param {*} packageId
     */
    onSendReminderClick = async (packageId) => {
        const { dispatch, getStakeholdersByPackageId, resendClientRemainder, getActualizedPackageForInvitation } = this.props
        let notInvited = false
        //check if must send  reminder or send invitation
        try {
            const dsStakeholders = await getStakeholdersByPackageId(packageId)

            dsStakeholders.forEach(stakeholder => {
                if (!stakeholder.isInvited && stakeholder.signerType !== "BROKER") {
                    notInvited = true
                }
            })

            // if is not invited we need to navigate to dsPackage and open email sender but first actualize package and check status
            if (notInvited) {
                const dsPackage = await getActualizedPackageForInvitation(packageId)
                if (canSendInvitation(dsPackage)) {
                    dispatch(setOpenInvitationEditorFromTicket(true))
                    dispatch(setCustomDsDocumentsModule(c.DSDOCUMENTS, null))
                    dispatch(setDSDocumentsOpenedPackage(packageId))
                    dispatch(setDSDocumentsSubModule('detailedPackage'))
                } else {
                    this.setState({ reminderConfirmationModal: true, invitationBlocked: true })
                }
            } else {
                //send manual reminder
                const reminderResponse = await resendClientRemainder(packageId)
                let reminderSentSuccessFlag
                if (reminderResponse && reminderResponse.success) {
                    reminderSentSuccessFlag = true
                }
                this.setState({ reminderConfirmationModal: true, reminderSentSuccessFlag })
            }

        } catch (error) {
            console.warn(error);
        }
    }

    /**
     * Open direct sign functionality from package list
     * @param {*} packageId
     */
    async onDirectSigningClick(packageId) {
        const { updatePackagesFromConnective, getOneDsPackageById } = this.props
        const responseFromConnective = await updatePackagesFromConnective([packageId])
        if (responseFromConnective.success) {
            const dsPackage = await getOneDsPackageById(packageId)
            let URLForSign = nesProp.get(dsPackage, "F2FSigningUrl")
            // this.setState({ dsPackage })
            window.open(URLForSign, '_blank', 'noopener,noreferrer')
        }
    }

    /**
     * This function return with values for email sender, collected from this module
     * depending on the current data structure.
     */
    async collectVariableValues(ticketObj, singleClientData, contractId, contract) {
        const { clientId } = this.props
        const { clientOptionsDict } = this.props
        const { documents } = contract || {}

        let emails = nesProp.get(singleClientData, "detail.emails")
        let clientName = nesProp.get(singleClientData, "main.name")

        // process email list to be digestible for email sender
        emails = emails && emails.map((item) => ({
            referenceId: clientId,
            label: clientName,
            value: item.email,
            default: (item.default == "true" || item.default == true) ? true : false
        })) || []

        emails = emails.sort((item, item2) => {
            if (item.default && !item2.default) { return -1 }
            if (!item.default && item2.default) { return 1 }
            if ((item.default && item2.default) || (!item.default && !item2.default)) { return 0 }
        }) || []

        // decode language of client from a word to a code. Ex. "Nederlands" to "nl"
        let clientLanguage = nesProp.get(singleClientData, "detail.language") || ''
        clientLanguage = getTheLanguageCodeByAnyLanguageOnAnyLanguage(clientLanguage, clientOptionsDict)

        return {
            contractNumber: contract && contract.contractMain.contractNumber,

            clientDocuments: nesProp.get(singleClientData, "clientDocuments"),
            clientDocumentsType: 'client',
            clientDocumentsId: clientId,

            // new v6 mode
            claimDocuments: [],
            claimDocumentsType: "claim",
            claimDocumentsId: null,

            contractDocuments: documents,
            contractDocumentsType: "contract",
            contractDocumentsId: contractId,

            clientId: false,
            contractId: contractId,
            claimId: false,
            company: contract && contract.contractMain.insuranceCompany,
            clientName: nesProp.get(singleClientData, "main.name"),
            clientNumber: nesProp.get(singleClientData, "main.clientNumber"),
            clientLanguage,
            clientEmails: emails,
            companyCancelMail: contract && contract.contractMain.companyCancelMail,

            brokerNumber: contract && contract.contractDetails.brokerNumber,

            clientData: nesProp.get(singleClientData, "main"),
            contractBranche: contract && contract.contractMain.contractBranche,
            ticketDocuments: this.convertTickerDocumentsToEmailAttachmentsForEmailer(ticketObj),
            autoSelectTemplate: true,
            startedFromModule: c.EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT
        }
    }

    /**
     * This function converts the ticket documents to email attachments
     * @param {*} ticketObject
     * @param {*} security
     * @returns
     */
    convertTickerDocumentsToEmailAttachmentsForEmailer(ticketObject) {
        return nesProp.get(ticketObject, "documents").map(oneDocId => {
            return {
                id: oneDocId,
                type: nesProp.get(ticketObject, 'typeDocument'),

                // give a redundant value in prop list on different name to be able to use the
                // attachment tool for tickets
                oracleDocumentId: oneDocId,
                oracleDocumentType: nesProp.get(ticketObject, 'typeDocument'),

                date: "",
                name: ""
            }
        })
    }

    /**
     * This function converts the ticket documents to email attachments
     * @param {*} ticketObject
     * @param {*} security
     * @returns
     */
    convertTickerDocumentsToEmailAttachmentsForWizard(ticketObject, security) {
        const dSDocumentOriginTypes = nesProp.get(security, "DigitalSignatureHardLists.DSDocumentOriginTypes")
        return nesProp.get(ticketObject, "documents").map(oneDocId => {
            return { oracleDocumentId: oneDocId, oracleDocumentType: nesProp.get(ticketObject, 'typeDocument'), origin: dSDocumentOriginTypes.DS_ORIGIN_ORACLE }
        })
    }

    /**
     * This method will navigate to relevant module (client profile, contract, tarification, claim) and open the dsWizard with selected ticket documents
     * Get client id
     * Prep the documents to attach
     * Navigate to module
     *
     * @param {*} selectedDocumentsList
     */
    async openDsWizardWithDocuments(selectedDocumentsList, attachmentDocumentsList, ticketObject) {
        const { getClientId, setNotification, security } = this.props
        const contractId = ticketObject && ticketObject.ticketDetails && ticketObject.ticketDetails.contractId
        const claimId = ticketObject && ticketObject.ticketDetails && ticketObject.ticketDetails.claimId
        const tarificationId = ticketObject && ticketObject.ticketDetails && ticketObject.ticketDetails.tarificationId
        const dSDocumentOriginTypes = nesProp.get(security, "DigitalSignatureHardLists.DSDocumentOriginTypes")
        const clientId = await getClientId(contractId, claimId, tarificationId)

        if (!clientId) {
            setNotification(_('ticketNoClientAffected'), 'error')
            return
        }

        const ticketDocuments = this.convertTickerDocumentsToEmailAttachmentsForWizard(ticketObject, security)
        const ticketId = nesProp.get(ticketObject, "id")
        //create documents objects
        const selectedTicketDocuments = []
        selectedDocumentsList.map(oneDocName => {
            const oneDocObj = {
                oracleDocumentId: oneDocName,
                oracleDocumentType: nesProp.get(ticketObject, 'typeDocument'),
                origin: dSDocumentOriginTypes.DS_ORIGIN_ORACLE,
                //use to identify the tickets tab in attachments modal
                documentSelectionTab: c.TICKET_DOCUMENTS_TAB
            }
            selectedTicketDocuments.push(oneDocObj)
        })

        const emailAttachmentTicketDocuments = []
        attachmentDocumentsList.map(oneDocName => {
            const oneDocObj = {
                oracleDocumentId: oneDocName,
                oracleDocumentType: nesProp.get(ticketObject, 'typeDocument'),
                origin: dSDocumentOriginTypes.DS_ORIGIN_ORACLE
            }
            emailAttachmentTicketDocuments.push(oneDocObj)
        })

        // if we have contractId we have to navigate to client contracts
        if (contractId) {
            this.navigateToClientContracts(
                clientId,
                contractId,
                {
                    selectedTicketDocuments: selectedTicketDocuments,
                    ticketDocuments,
                    ticketId,
                    emailAttachmentTicketDocuments
                }
            )
            // stop here this function
            return
        }

        if (tarificationId) {
            this.navigateToClientTarifications(
                clientId,
                tarificationId,
                {
                    selectedTicketDocuments: selectedTicketDocuments,
                    ticketDocuments,
                    ticketId,
                    emailAttachmentTicketDocuments
                }
            )
            // stop here this function
            return
        }

        // if we have ClaimId we have to navigate to client claims
        if (claimId) {
            this.navigateToClientClaims(
                clientId,
                claimId,
                {
                    selectedTicketDocuments: selectedTicketDocuments,
                    ticketDocuments,
                    ticketId,
                    emailAttachmentTicketDocuments
                }
            )
        }
    }

    /**
     * Handles the the taskCreator modal visibility toggeling
     */
    handleTaskCreatorModalToggling = () => {
        const { taskCreatorModalToggle } = this.props
        taskCreatorModalToggle()
    }

    /**
     * Handles navigation to a singed document that has not been linked to a contract but it requires a contract
     * @param {*} documentId
     * @returns
     */
    navigateToUnlinkedDocument(documentId) {
        const { dispatch, module: currentModule } = this.props
        return dispatch(navigateToDsDocumentFromTicket(documentId, c.DSDOCUMENTS, currentModule))
    }

    /**
     * Converts the inbox items to task `shape` objects to be readable by the taskCreator component
     * @param {array} items the list of data to be converted
     * @return {array} the task `shape` objects generated data
     */
    generateTaskCreatorItems = (items) => {
        let convertedItems = []
        let selectedItems = items.filter(item => item.checked)

        if (selectedItems.length > 0) {
            selectedItems.map((value, key) => {
                let ticketDetail = ''
                let ticketDocuments = null
                let ticketDoctype = null
                let ticketReferral = null

                // Parse the data of the object as a string with newlines
                if (value.ticketDetails && value.ticketDetails instanceof Object) {
                    Object.keys(value.ticketDetails).map((objectKey, index) => {
                        let detailValue = value.ticketDetails[objectKey]

                        // skip few values to show : BEWB-730
                        if (["portal_cat_ticket", "beheerder"].indexOf(objectKey) > -1) {
                            return
                        }

                        ticketDetail = ticketDetail + " " + objectKey + ': "' + detailValue + '"</br>'
                    })
                }
                else {
                    if (value.ticketDetails !== undefined) {
                        ticketDetail = value.ticketDetails
                    }
                }

                if (value.documents !== undefined) {
                    ticketDocuments = value.documents
                }

                if (value.typeDocument !== undefined) {
                    ticketDoctype = value.typeDocument
                }

                if (value.ticketUniqueId !== undefined) {
                    ticketReferral = value.ticketUniqueId
                }

                convertedItems.push({
                    title: value.ticketDescription,
                    description: ticketDetail,
                    endDate: value.ticketDate,
                    ticketReferral: value.id,
                    taskRelation: null,
                    ticketDocuments: ticketDocuments,
                    ticketDoctype: ticketDoctype,
                    ticketMsgLink: ticketReferral
                })
            })
        }

        return convertedItems
    }

    /**
     *
     * @param {*} event
     * @param {*} doc
     * @param {*} itemId
     * @param {*} typeDocument
     * @param {string} sourceOfDocument - there are few source of files like ticket or dsdocument, values from contants
     */
    setCheckedDoc(event, doc, itemId, typeDocument, sourceOfDocument) {
        const { documentCheckList } = this.state
        if (!documentCheckList[itemId]) {
            documentCheckList[itemId] = []
        }

        // not used
        let checked = event.target.checked

        let docString = String(doc)
        let docIndex = documentCheckList[itemId].findIndex(
            item => ((item.id === docString) && (item.typeDocument === typeDocument))
        )

        if (docIndex == -1) {
            documentCheckList[itemId].push({ id: docString, typeDocument, sourceOfDocument })
        } else {
            documentCheckList[itemId].splice(docIndex, 1)
        }

        this.setState({ documentCheckList })
    }

    /**
     * Verify is an item checked and return a boolean value.
     * @param {*} doc
     * @param {*} itemId
     * @param {*} typeDocument
     * @returns {bool} item is checked value
     */
    thisCheckBoxIsChecked(doc, itemId, typeDocument) {
        const { documentCheckList } = this.state

        if (!documentCheckList || !documentCheckList[itemId]) {
            return false
        }

        let docString = String(doc)
        let docIndex = documentCheckList[itemId].findIndex(
            item => ((item.id === docString) && (item.typeDocument === typeDocument))
        )

        if (docIndex == -1) {
            return false
        }

        return true
    }

    /**
     * This function will clear the selection of documents.
     */
    clearSelectionOfDocument() {
        // this clear the ticket selection checkboxes
        this.clearSelectionOfTickets()

        // this line clear subslection of documents inside the tickets globally
        this.setState({ documentCheckList: {} })
    }

    /**
     * This function will clear the selection of tickets.
     */
    clearSelectionOfTickets() {
        const { items, deselectItems } = this.props
        let filteredItems = items.filter(item => item.checked) || []

        if (filteredItems && filteredItems.length > 0) {
            deselectItems()
        }
    }

    /**
     * Handle the download when clicked on download button after document in a ticket.
     * @param {string} itemId
     */
    downloadSelected(itemId) {
        const { documentCheckList } = this.state

        if (!documentCheckList[itemId]) {
            return false
        }

        let docsToDownload = documentCheckList[itemId]

        this.startDownloadProgressByListOfDocuments(docsToDownload, itemId)
    }

    /**
     *  This function popup the waiting dialog and start the download progress using a list of document.
     * @param {array} docsToDownload list of documents
     * @param {string} itemId ticketID but any string is ok, used for filename.
     */
    startDownloadProgressByListOfDocuments(docsToDownload, itemId = '') {
        if (!underscore.isEmpty(docsToDownload)) {
            // set flag for visual elements (waiting modal etc.)
            this.switchWaitingModal(true, _("collectingDocumentPleaseWait"), _("pleaseWaitTitle"))
            this.setState({ precacheInProgress: true })

            // start the progress
            this.doThePrecache(docsToDownload)
                // the same action in "catch" and "then" because the "finally" not supported in IE
                .then((result) => {
                    this.handleCacheProgressResult(result.docsCached, result.failedToCache, itemId)
                })
                .catch((err) => {
                    this.handleCacheProgressResult()
                })
                .then((result) => {
                    // anyway come here
                    this.clearSelectionOfDocument()
                })
        }
    }

    /**
     * This function start a global download method over the ticket documents
     */
    handlerDownloadGlobalSelectChange(ticketItemsSelected) {
        const { documentCheckList } = this.state

        let listOfAllGlobalSelectedDocuments = []

        // collect ticket selection documents
        if (ticketItemsSelected.length > 0) {
            ticketItemsSelected.forEach((item) => {
                let currentListOfDocIDs = []
                if (item.checked && item.documents && item.documents.length) {
                    item.documents.forEach((oneDoc) => {

                        currentListOfDocIDs.push({
                            id: String(oneDoc),
                            typeDocument: item.typeDocument
                        })

                    })
                }
                listOfAllGlobalSelectedDocuments = listOfAllGlobalSelectedDocuments.concat(currentListOfDocIDs)
            })
        }

        // collect ticket documents selected
        if (documentCheckList && Object.keys(documentCheckList).length > 0) {
            Object.keys(documentCheckList).forEach((oneObjKey) => {
                listOfAllGlobalSelectedDocuments = listOfAllGlobalSelectedDocuments.concat(documentCheckList[oneObjKey])
            })
        }

        this.startDownloadProgressByListOfDocuments(listOfAllGlobalSelectedDocuments, '')
    }

    /**
     * Show result if there are missing or inaccessible files for the user.
     * @param {*} docsCached
     * @param {*} failedToCache
     */
    handleCacheProgressResult(docsCached, failedToCache, itemId) {
        this.setState({ precacheInProgress: false })

        if ((failedToCache && failedToCache.length > 0) || !docsCached || docsCached.length <= 0) {
            this.switchWaitingModal(
                true,
                _("docsNotFound") + " " + (failedToCache && failedToCache.join(", ") || ""),
                _("docsNotFoundTitle"),
                (shouldContinue = true) => {
                    if (shouldContinue && docsCached && docsCached.length > 0) {
                        this.handlePrepareDownloadZip(docsCached, itemId)
                    } else {
                        this.switchWaitingModal(false)
                    }
                }
            )
        } else {
            this.handlePrepareDownloadZip(docsCached, itemId)
        }
    }

    /**
     * Open the modal what contains the link to the zip file
     * @param {*} docsCached
     */
    handlePrepareDownloadZip(docsCached, itemId) {
        const { ticket } = this.state
        this.switchWaitingModal(
            true,
            _("clickLinkBelowToDownloadZip"),
            _("download"),
            !docsCached || docsCached.length === 0 ? (() => { this.switchWaitingModal(false) }) : null,
            docsCached && docsCached.length > 0 ?
                {
                    link: this.getZipLink(docsCached, itemId),
                    callBack: () => { this.switchWaitingModal(false) }
                } : null
        )
    }

    /**
     * This function will generate the link toward the zip file
     * @param {*} docsCached
     * @param {*} itemId
     */
    getZipLink(docsCached, itemId) {
        let onlyIds = []
        docsCached && docsCached.forEach((item) => {
            onlyIds.push(item.localId)
        })

        return '/zipDocuments?ticketId=' + itemId + '&documentList=' + onlyIds.join(',')
    }

    /**
     * This function calls the api to zip the cached documents.
     * @param {object} docsCached
     */
    callZipping(docsCached) {
        const { downloadDocumentsZip } = this.props
        return downloadDocumentsZip(docsCached)
    }

    /**
     * This function will do a precache for a list of documents and fire a callback function
     * with the extended values
     * @param {array} docsToDownload - list of documents -> id, date, docType
     */
    doThePrecache(docsToDownload) {
        const { preCacheDocumentsBulk } = this.props

        let cachingResult = {
            docsCached: [],
            failedToCache: [],
            error: {}
        }

        return preCacheDocumentsBulk(docsToDownload)
            .then((results) => {
                let errorPrecacheList = []

                // let attachemntsWhatCached = []
                // find the related attachment to give back the local id
                if (docsToDownload && docsToDownload.length > 0 && results && results.length > 0 &&
                    results.length == docsToDownload.length) {

                    // extend document list with "localId" property if cache don successfully
                    docsToDownload.forEach((docValue) => {
                        results.forEach((resVal) => {
                            if ((docValue.id == nesProp.get(resVal, "data.id"))) {
                                docValue.localId = nesProp.get(resVal, "data.localId")
                            }
                        })

                        if (!docValue.localId) {
                            errorPrecacheList.push(docValue.id)
                        }
                    })
                }

                cachingResult.docsCached = docsToDownload.filter((item) => {
                    return item.localId
                })

                cachingResult.failedToCache = errorPrecacheList

                return cachingResult
            }).catch((err) => {
                return cachingResult.error = err
            })
    }

    /**
     * This function handle the waiting modal for download documents.
     * @param {bool} show - modal show or hide
     * @param {string} text - modal content
     * @param {string} title - modal title
     * @param {function} waitingModalOkButtonCallback is empty the no button shown, else ok button call
     * @param {object} waitingModalOkButtonLink optional, link for a file
     * the function given as value.
     */
    switchWaitingModal(show = true, text = "", title = "", waitingModalOkButtonCallback = null, waitingModalOkButtonLink = null) {
        this.setState({
            waitingModal: show,
            waitingModalText: text,
            waitingModalTitle: title,
            waitingModalOkButtonCallback: waitingModalOkButtonCallback,
            waitingModalOkButtonLink: waitingModalOkButtonLink,
        })
    }

    /**
     *  This function render the waiting modal content until the zipped documents prepare.
     */
    waitingPopup() {
        const { waitingModalText, waitingModalTitle, waitingModalOkButtonCallback, waitingModalOkButtonLink } = this.state

        return (
            <div className={styles.archiveModalContent}>
                <span className={styles.title}>{waitingModalTitle}</span>
                <span className={styles.message}>{waitingModalText}</span>
                {waitingModalOkButtonCallback && typeof waitingModalOkButtonCallback == 'function' &&
                    <div className={styles.archiveModalButtons}>
                        <span
                            onClick={() => (waitingModalOkButtonCallback(false))}
                            className={styles.cancel}
                        >
                            {_("cancel")}
                        </span>
                        <div className={styles.greyButton + " enabled"}
                            onClick={() => (waitingModalOkButtonCallback(true))}
                        >
                            {_('ok')}
                        </div>
                    </div>
                }

                {waitingModalOkButtonLink && waitingModalOkButtonLink.link &&
                    <div className={styles.archiveModalButtons}>
                        <span
                            onClick={() => (this.switchWaitingModal(false))}
                            className={styles.cancel}
                        >
                            {_("cancel")}
                        </span>
                        <a download="true" target="_blank" href={waitingModalOkButtonLink.link}
                            onClick={waitingModalOkButtonLink.callBack}
                            className={styles.greyButton + " enabled"}
                            rel="noopener noreferrer"
                        >
                            {_("download")}
                        </a>
                    </div> || null
                }

            </div>
        )
    }

    /**
     * This function check a ticket document list and return true if there are checked elements.
     *
     * @param {*} itemId
     */
    buttonIsEnabledForDownload(itemId) {
        const { documentCheckList } = this.state

        if (!documentCheckList[itemId]) {
            return false
        }

        if (documentCheckList[itemId].length <= 0) {
            return false
        }

        return true
    }

    /**
     * renders the link button once the dsDocuments are loaded
     * @param {*} dsDocuments
     * @param {*} dsDocTemplates
     * @param {*} documentId
     * @param {*} key
     * @returns
     */
    linkButton(dsDocuments, dsDocTemplates, documentId, key) {
        if (dsDocuments.length === 0 || dsDocTemplates.length === 0) {
            return <div></div>
        }

        let dsDocument = dsDocuments.find(doc => doc.id === documentId)
        return (
            <LinkAndUploadButton
                dsDocument={dsDocument}
                templates={dsDocTemplates || []}
                openLinkAndUploadWizard={(dsDocument) => {
                    return this.openLinkAndUploadWizard(dsDocument)
                }}
                key={key + "LinkAndUploadButtonkey"}
            />
        )
    }

    /**
     * This function clean up the details object.
     * No cleanDetail kept
     * @param {*} details
     * @returns
     */
    getDetailsWithoutClientLabel(details) {

        if (typeof details !== 'object') {
            return details
        }

        let cleanDetail = JSON.parse(JSON.stringify(details))
        if (cleanDetail.clientLabel) {
            delete cleanDetail.clientLabel
        }

        // skip few values to show, they are used only for backround hadnling processes, not for users to show : BEWB-730
        if (cleanDetail.portal_cat_ticket) {
            delete cleanDetail.portal_cat_ticket
        }

        if (cleanDetail.beheerder) {
            delete cleanDetail.beheerder
        }

        return cleanDetail
    }

    /**
      * Open the model for linking or uploading document
      * @param {*} dsDocument
      */
    openLinkAndUploadWizard(dsDocument) {
        this.setState({ isOpenLinkDocumentModal: dsDocument })
    }

    render() {
        const { isOpened, archiveIsOpen, confirmationModal, waitingModal, isOpenLinkDocumentModal, signDocumentsModalIsOpen,
            clientLinkingIsOpen, /*emailerIsOpen,*/ moduleOptionsForEmail, moduleKeyToSet, reminderConfirmationModal,
            reminderSentSuccessFlag, invitationBlocked } = this.state
        const { items, filterTicket, selectValue, getInbox, setTicketUnread, staff, dsDocTemplates, dsDocuments } = this.props
        const checkedItemCount = items.reduce((a, b) => a + (b.checked ? 1 : 0), 0)
        const { visibilityOf } = this.state
        const { modalIsOpen } = this.props.archiveData
        const downloaddoc = this.getDownloadDocSecurity()
        const createEmail = this.getEmailSecurity()
        const allSelected = items && items.length > 0 && items.every(item => (
            visibilityOf[item.id] ? item.checked : true
        ))
        this.allSelected = allSelected
        const filteredItems = items.filter(item => !item.hidden)

        // Needs to be defined here so translations are updated
        const filterOptions = [
            { value: 'showAll', label: _('showAll') },
            { value: 'showUnread', label: _('showUnread') },
            { value: 'showRead', label: _('showRead') },
            { value: 'hasTaskCompleted', label: _('hasTaskCompleted') },
            { value: 'hasTaskUncompleted', label: _('hasTaskUncompleted') }
        ]

        return (
            <ComponentPageDom
                title={_('title')}
                subtitle={_('subtitle')}
            >
                <div className={styles.results}>
                    <Table
                        onVisibleChange={this.handleVisibleList}
                        topPaginationElemL={
                            [
                                <div key="x1z">
                                    <SelectWrap
                                        key="s"
                                        value={selectValue}
                                        options={filterOptions}
                                        onChange={(v) => {
                                            filterTicket(v.value)
                                        }}
                                    />
                                </div>,
                                <RefreshBtn
                                    key="r"
                                    onClick={() => {
                                        getInbox(true)
                                    }}
                                />,
                            ]
                        }
                        topPaginationElemR={this.archiveBtn(checkedItemCount, filteredItems, downloaddoc)}
                        filterable={[
                            "ticketDate",
                            "ticketDescription",
                            "ticketType",
                            "ticketDocumentNames",
                        ]}
                        ref={el => { this.table = el }}
                        id="table"
                        className="table"
                        sortable={[
                            { column: 'ticketDate', sortFunction: 'Date' },
                            'ticketDescription',
                            'ticketType',
                        ]}
                        defaultSort={{
                            column: 'ticketDate',
                            direction: 'desc',
                        }}

                        itemsPerPage={50}
                        pageButtonLimit={5}
                    >
                        <Thead>
                            <Th column="collapse" label="" />
                            <Th column="checkbox">
                                <input
                                    type="checkbox"
                                    checked={allSelected}
                                    onChange={this.handleCheckAll}
                                />
                            </Th>
                            <Th column="ticketDate">
                                <strong>{_("ticketDate")}</strong>
                            </Th>
                            <Th column="ticketDescription">
                                <strong>{_("ticketDescription")}</strong>
                            </Th>
                            <Th column="ticketOperations" label="">
                            </Th>
                            <Th column="ticketType">
                                <strong>{_("ticketType")}</strong>
                            </Th>
                            <Th column="status">
                                <strong>{_("ticketStatus")}</strong>
                            </Th>
                        </Thead>

                        {filteredItems.map((item, key) => {
                            let ticketCategoryId = nesProp.get(item, "ticketDetails.portal_cat_ticket")
                            const isExpanded = isOpened[item.id]
                            let quickReplyEnabled = ticketCategoryId && TICKET_CATEGPRIES_WHITE_LIST_FOR_QUICK_REPLY.includes(ticketCategoryId + "")

                            return (<Tr
                                className={item.unread ? `${styles.unread} clickable` : `clickable`}
                                i={item.id}
                                key={key}
                                onClick={() => {
                                    this.switch(item.id)
                                    if (item.unread) {
                                        setTicketUnread(item.id, false)
                                    }
                                }}
                            >
                                {collapseTd({
                                    column: 'collapse',
                                    isOpened: isOpened[item.id],
                                    children: (
                                        <div className={cs(styles.content, 'collapseWrapper')} data-ticketIdAttr={item.id}>
                                            <div key={"TdDetailsKey"}>
                                                <h2>{_('details')}</h2>
                                                {item.ticketDetails && item.ticketDetails.clientLabel &&
                                                    <div>
                                                        {_("clientLabel") + " " + item.ticketDetails.clientLabel}
                                                    </div>
                                                }
                                                <DOMify value={this.getDetailsWithoutClientLabel(item.ticketDetails)} />
                                            </div>
                                            {item.unlinkedDocumentId &&
                                                <div key={"UnlinkedDocumentKey"}>
                                                    <h2>{_("unlinkedDocument")}</h2>
                                                    <div className={styles.documents}>
                                                        <div className={styles.unlinkedDocument}>
                                                            <a
                                                                key={key + "download_link"}
                                                                href={`/data/document?id=${item.unlinkedDocumentId}&type=${item.typeDocument}&source=${DOCUMENT_FILE_SOURCE_DSDOCUMENT}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                {item.unlinkedDocumentFileName}
                                                            </a>
                                                            <div className={styles.linkButton}>
                                                                {this.linkButton(dsDocuments, dsDocTemplates, item.unlinkedDocumentId, key)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {item.documents && item.documents.length > 0 &&
                                                <div key={"TdDocumentsKey"}>
                                                    <h2>{_('documents')}</h2>
                                                    <div className={styles.documents}>
                                                        {item.documents.map((doc, key) =>
                                                        (
                                                            <div>
                                                                {downloaddoc && <input
                                                                    key={"check_" + key}
                                                                    type="checkbox"
                                                                    onChange={(event) => {
                                                                        this.setCheckedDoc(
                                                                            event,
                                                                            doc,
                                                                            item.id,
                                                                            item.typeDocument,
                                                                            DOCUMENT_FILE_SOURCE_TICKET_DOCUMENT
                                                                        )
                                                                    }}
                                                                    checked={this.thisCheckBoxIsChecked(doc, item.id, item.typeDocument)}
                                                                />}
                                                                <a
                                                                    key={key}
                                                                    href={`/data/document?id=${doc}&type=${item.typeDocument}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    {doc}
                                                                </a>
                                                            </div>
                                                        )
                                                        )}
                                                    </div>
                                                    {downloaddoc &&
                                                        <div className={styles.archiveModalButtons} key={item.id + "DownloadButtonKey"}>
                                                            <input
                                                                onClick={() => this.downloadSelected(item.id)}
                                                                disabled={Boolean(!this.buttonIsEnabledForDownload(item.id))}
                                                                type="button"
                                                                className={styles.greyButton}
                                                                value={_("downloadSelectedDocuments")}
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            {item.relatedTasks.map((itemData, key) =>
                                                <div className={styles.inboxUserNames}
                                                    key={"TdinboxUserNamesKey" + key}
                                                >
                                                    {this.getStaffName(itemData.userId)} - {this.getTaskStatus(itemData.isCompleted)} - {itemData.title}
                                                </div>
                                            )}
                                        </div>
                                    ),
                                })}
                                <Td column="checkbox" value={map(item.ticketDetails, i => i).join(' ')}>
                                    <div style={{ width: 15 }}>
                                        <input
                                            type="checkbox"
                                            onClick={ev => ev.stopPropagation()}
                                            onChange={ev => this.check(ev, item.id)}
                                            checked={item.checked}
                                        />
                                    </div>
                                </Td>
                                <Td
                                    column="ticketDate"
                                    value={
                                        // a little hack with MongoDB id as timestamp for sorting
                                        item.ticketDate.toString() + item.id
                                    }
                                >
                                    {dateFormatter(item.ticketDate)}
                                </Td>
                                <Td column="ticketOperations" children={(
                                    (item.ticketDetails && (item.ticketDetails.contractId || item.ticketDetails.claimId || item.ticketDetails.tarificationId)) ?
                                        <div className={styles.iconWrapper}>
                                            <span className={styles.goToContractWrapper}>
                                                <img className={cs(styles.inboxToolIcon)} src={this.getIcon('baseline-reply-24px-green.svg')}
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        this.gotToContractOrClaimOfClient(item, false)
                                                    }}
                                                />
                                                <span className={cs([styles.tooltip, styles.goToContractTooltip])}>{_('goToContractTooltip')}</span>
                                            </span>
                                            {createEmail &&
                                                <span className={styles.createEmailWrapper}>
                                                    <img className={cs(styles.inboxToolIcon)} src={this.getIcon('icn-inbox-blue.svg')}
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            this.gotToContractOrClaimOfClient(item, true)
                                                        }}
                                                    />
                                                    <span className={cs([styles.tooltip, styles.createEmailTooltip])}>{_('createEmailTooltip')}</span>
                                                </span>
                                            }
                                            {createEmail && quickReplyEnabled &&
                                                <span className={styles.quickReplyWrapper}>
                                                    <img className={cs(styles.inboxToolIcon)} src={this.getIcon('baseline-reply-to-willemot-24px-green.svg')}
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            //this.openEmailer(item, true)
                                                            this.gotToContractOrClaimOfClient(item, true, true, true)
                                                        }}
                                                    />
                                                    <span className={cs([styles.tooltip, styles.quickReplyTooltip])}>{_('quickReplyTooltip')}</span>
                                                </span>
                                            }

                                            {item.documents && item.documents.length > 0 &&
                                                <span className={styles.signDocumentsWrapper}>
                                                    <img className={cs(styles.inboxToolIcon)} src={this.getIcon('a-edit_1x_blue.svg')}
                                                        onClick={(e) => {
                                                            this.setState({ signDocumentsModalIsOpen: item })
                                                        }}
                                                    />
                                                    <span className={cs([styles.tooltip, styles.signDocumentsTooltip])}>{_('signDocumentsTooltip')}</span>
                                                </span>
                                            }

                                        </div>
                                        :
                                        <div className={styles.iconWrapper}>
                                            {(item.ticketType === 'Bloc Retour' && !item.linkedClient ?
                                                <span className={styles.blockRetourWrapper}>
                                                    <img className={cs(styles.inboxToolIcon, styles.linkClientIcon)} src={this.getIcon('person_search_green.svg')}
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            this.setState({ clientLinkingIsOpen: item })
                                                        }}
                                                    />
                                                    <span className={cs([styles.tooltip, styles.blockRetourTooltip])}>{_('blockRetourTooltip')}</span>
                                                </span> :
                                                ''
                                            )}

                                            {createEmail && quickReplyEnabled &&
                                                <span className={styles.quickReplyWrapper}>
                                                    <img className={cs(styles.inboxToolIcon)} src={this.getIcon('baseline-reply-to-willemot-24px-green.svg')}
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            // this.openEmailer(item, true)
                                                            this.gotToContractOrClaimOfClient(item, true, true, true)
                                                        }}
                                                    />
                                                    <span className={cs([styles.tooltip, styles.quickReplyTooltip])}>{_('quickReplyTooltip')}</span>
                                                </span>
                                            }

                                            {(item.ticketDetails.packageId) ?
                                                <span className={styles.goToPackageWrapper}>
                                                    <img className={cs([styles.inboxToolIcon, styles.goToPackageIcon])} src={this.getIcon('baseline-reply-24px-green.svg')}
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            this.onNavigateToPackageClick(item.ticketDetails.packageId)
                                                        }}
                                                    />
                                                    <span className={cs([styles.tooltip, styles.goToPackageTooltip])}>{_('goToPackageTooltip')}</span>
                                                </span>
                                                : ''
                                            }
                                            {item.ticketDetails.packageId && item.statusFromPackage && (item.statusFromPackage == 'packageStatusPending' ||
                                                item.statusFromPackage == 'emailSentWithLink') &&
                                                <span className={styles.sendReminderWrapper}>
                                                    < img className={cs(styles.inboxToolIcon)} src={this.getIcon('notification-bell.svg')}
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            this.onSendReminderClick(item.ticketDetails.packageId)
                                                        }}
                                                    />
                                                    <span className={cs([styles.tooltip, styles.sendReminderTooltip])}>{_('sendReminderTooltip')}</span>
                                                </span>

                                            }
                                            {item.ticketDetails.packageId && item.statusFromPackage && (item.statusFromPackage == 'packageStatusPending' ||
                                                item.statusFromPackage == 'emailSentWithLink') &&
                                                <span className={styles.directSignWrapper}>
                                                    < img className={cs(styles.inboxToolIcon)} src={this.getIcon('a-edit_1x_blue.svg')}
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            this.onDirectSigningClick(item.ticketDetails.packageId)
                                                        }}
                                                    />
                                                    <span className={cs([styles.tooltip, styles.directSignTooltip])}>{_('directSignTooltip')}</span>
                                                </span>

                                            }
                                        </div>
                                )}>
                                </Td>
                                <Td column="ticketDescription" value={item.ticketDescription}>
                                    <div className="ticket-description" 
                                         data-ticketIdAttr={item.id} 
                                         style={{
                                                    whiteSpace: 'pre-line', 
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: isExpanded ? 1000 : 1,
                                                    WebkitBoxOrient: 'vertical',
                                                    wordBreak: 'break-word',
                                                    overflowWrap: 'break-word',
                                                }} 
                                    >{item.ticketDescription}</div>
                                </Td>
                                <Td column="status">{item.statusFromPackage ? _(item.statusFromPackage) : ''}</Td>
                                <Td className={rt.typeCol} column="ticketType">{item.ticketType}</Td>
                                <Td column="ticketDocumentNames">{item.ticketDocumentNames}</Td>
                            </Tr>)
                        }
                        )}
                    </Table>
                </div>
                <TaskCreator
                    modalTitle={'inboxTaskCreatorModalTitle'}
                    taskItems={this.generateTaskCreatorItems(items)}
                    staffItems={staff}
                    convertionType="inbox"
                />
                <InboxDocumentsSigningModal
                    modalIsOpen={signDocumentsModalIsOpen ? true : false}
                    onCancel={() => {
                        this.setState({ signDocumentsModalIsOpen: null })
                    }}
                    method={(documentsList, attachmentDocumentsList, ticketObject) => {
                        this.setState({ signDocumentsModalIsOpen: null })
                        return this.openDsWizardWithDocuments(documentsList, attachmentDocumentsList, ticketObject)
                    }}
                    payload={signDocumentsModalIsOpen ? { ticket: signDocumentsModalIsOpen } : {}}
                >

                </InboxDocumentsSigningModal>
                <Modal
                    isOpen={confirmationModal}
                    style={customStyles}
                    key={"archiveConfirmPopupKey"}
                    contentLabel={""}
                /*className={styles.modal}*/
                >
                    {this.archiveConfirmPopup()}
                </Modal>
                <Modal
                    isOpen={waitingModal}
                    style={customStyles}
                    key={"waitingPopupKey"}
                    contentLabel={""}
                >
                    {this.waitingPopup()}
                </Modal>

                <ReminderEmailStatusDialog
                    isOpen={reminderConfirmationModal}
                    success={reminderSentSuccessFlag}
                    invitationBlocked={invitationBlocked}
                    closeModal={() => this.setState({ reminderConfirmationModal: false, invitationBlocked: false, reminderSentSuccessFlag: false })}
                />

                <LinkDocumentModal
                    modalIsOpen={!!isOpenLinkDocumentModal}
                    onCancel={() => {
                        this.setState({ isOpenLinkDocumentModal: false })
                        this.refresh(true)
                    }}
                    onConfirmation={() => {
                        this.refresh(true)
                        this.setState({ isOpenLinkDocumentModal: false })
                    }}
                    flag={'LinkDocumentModal'}
                    payload={isOpenLinkDocumentModal ?
                        {
                            dsdocument: isOpenLinkDocumentModal
                        } : {}
                    }
                />

                {/*emailerIsOpen &&
                    <EmailButton
                        moduleKeyToSet={moduleKeyToSet}
                        moduleOptions={moduleOptionsForEmail}
                        modalId={c.EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT}
                        hideButton={true}
                        forceOpen={true}
                        onSentLate={() => {
                            this.setState({ emailerIsOpen: fasle })
                        }}
                    />
                */}
                <ClientLinkingModal
                    isOpen={!!clientLinkingIsOpen}
                    customStyles={customStyles}
                    key={"ClientLinkingModal"}
                    ticket={clientLinkingIsOpen}
                    onClose={() => this.setState({ clientLinkingIsOpen: '' })}
                    setNotification={setNotification}
                />

            </ComponentPageDom>
        )
    }
}



// WEBPACK FOOTER //
// ./components/inbox.jsx